'use strict';

import logger from "kernel/logger/Logger";
import framefactory from "kernel/iframefactory/IFrameFactory";
import resizeManager from "kernel/resizer/Resizer";

/**
 * @module subsystem/SubsystemManager
 * @memberof kernel
 * @description Manages loading and configuration of subsystem components
 */
///define(function(require){

	var publishers = {};
	var requiredPublishers = {"consoleservice":{},"clientservice":{}, "game":{}};
	var internalInit = false;
	var wrapperedDataReady = false;
	var bus,config,rootContainer,gameframe,splashContainer,splashframe;
	var wrapperedConfig;
	var gameContainer;
	var gameBlocker; //originally implemented in SKATE-6510, manually added to 1.4.16 as our overall setup is different to 1.4.15
	var	widgetContainer;
	var progressSubscriber;
	var clientServiceInitialised,consoleServiceInitialised, gameServiceInitialised;
	var gameLoadComplete;
	var loadingFailed, loadingFailedReason;
	var loadFailDebounce = false; //Stop from sending a load progress fail every 30 seconds from the first fail
	var clientServiceInitSubscriber, consoleServiceInitSubscriber, gamesServiceInitSubscriber;
	var queuedLoadingElements=[]; // Loading is initiated by adding to the DOM. Queue up all the constructed elements here.
	var queuedConsoleElements=[]; // separate queue for console elements. To alleviate potential race when hooking up to Op Console

	var consoleConfig,customViews={},layout;
	var loadingTimeout;
	var cecCommand;
	var gsEnabled = false;

	var gameCapabilities = {
		switchPlayModeSupport: false
	};

	var gameLoadingStartTimestamp = 0;

	/**
	 * @function init
	 * @description Initialise the SubsystemManager with configuration
	 * @instance
	 * @param bus {Function} a wrapped instance of Message Bus
	 * @param done {Function} callback to apply when complete
	 * @returns void
	 * @example
	 * subsystemManager.init(bus,done);
	 */
	function init(busModule, config, done){

		// Store reference to our message bus instance
		bus = busModule;
		gsEnabled = config.gsEnabled;

		// Subscribe to all releveant bus channels/topics
		progressSubscriber = bus.subscribe({channel:"Kernel",topic:"LoadProgress",callback:onSubsystemLoadProgress});



		//bus.subscribe({channel: 'ConsoleService', topic: 'Option.SetSize', callback: overrideResizer }); //SKATE-6458

		// bus.subscribe({channel: 'ConsoleService', topic: 'Option.disableIOSBarFix', callback: function(data) {
		// 	iOSBarWorkaround = false;
		// }});

		bus.subscribe({channel: 'ConsoleService', topic: 'Option.PinchZoomFixer', //SKATE-2270, allow bypass by PSU
			callback: function (data) {
				//zoomBlock = data.enabled;
				// SKATE-2498 - Disable zoomblock + ignore console
			}
		});

		// bus.subscribe({
		// 	channel: 'GameService',
		// 	topic: 'Widget.PositionGame',
		// 	callback: function(positionData) {
		// 		if (!positionData) { //Widget.PositionGame with no data removes the ovveride
		// 			overrideGamePositioningFromWidget = void(0);
		// 			sizesDirty = true;
		// 			resizeManager.resizer();
		// 		} else if (positionData.game && gameLoadComplete) {
		// 			if (!overrideGamePositioningFromWidget ||
		// 				(overrideGamePositioningFromWidget.left !== positionData.game.left || overrideGamePositioningFromWidget.top !== positionData.game.top ||
		// 					overrideGamePositioningFromWidget.width !== positionData.game.width || overrideGamePositioningFromWidget.height !== positionData.game.height ||
		// 					overrideGamePositioningFromWidget.z !== positionData.game.z)) {
		// 				overrideGamePositioningFromWidget = positionData.game;
		// 				//if (gameservicepanel && overrideGamePositioning.hasOwnProperty('z')) {
		// 				//	gameContainer.style.zIndex = overrideGamePositioning.z;
		// 				//}
		//
		// 				sizesDirty = true;
		// 				resizer();
		// 			}
		// 		}
		// 	}
		// });

		// Listen for ClientService subsystem initialised
		clientServiceInitSubscriber = bus.subscribe({
			channel:"ClientService",
			topic:"ClientService.InitDone",
			callback:function(data,envelope){
				clientServiceInitialised = true;
				onSubsystemsReady(); //checkLoadComplete removed - we don't need to call checkLoadProgress anymore.
		}});

		// Listen for ConsoleService subsystem initialised
		consoleServiceInitSubscriber = bus.subscribe({
			channel:"ConsoleService",
			topic:"ConsoleService.InitDone",
			callback:function(data,envelope){
				consoleServiceInitialised = true;
				onSubsystemsReady();
		}});	

		if(gsEnabled){
			requiredPublishers["gameservice"] = {};

			gamesServiceInitSubscriber = bus.subscribe({
				channel: "GameService", 
				topic: "GameService.InitDone",
				callback: function(data, envelope){
					gameServiceInitialised = true;
					onSubsystemsReady();
				}
			});
		}

		// Init done continuation
		done();
	}

	/**
	 * @function setStyles
	 * @private
	 * @instance
	 * @description helper method for styling DOM elements
	 * @param styles {object} styles to apply to DOM elements
	 * @returns {setStyles}
	 */
	function setStyles(styles){
		/* jshint validthis: true */
		Object.keys(styles).forEach(function(style){
			this.style[style] = styles[style];
		},this);

		return this;
	}

	/**
	 * @function setStyles
	 * @private
	 * @instance
	 * @description helper method for get origin of URL
	 * @param url {string}  URL
	 * @returns {string} URL origin
	 */
	function getUrlOrigin(url){
		var origin;
		var ln = document.createElement('a');
		ln.href = url;
		if(ln.origin){
			origin = ln.origin;
		}else{
			origin = ln.protocol+'//'+ln.host;
			if(origin === '//'){ // in case there is no support protocol and host api
				origin = window.location.protocol + "//" 
						    + window.location.hostname 
						    + (window.location.port ? ':' + window.location.port : ''); // supposed the same origin with the entry page
			}
		}
		return origin;
	}

	/**
	 * @function create
	 * @instance
	 * @description Generate the Subsystem IFrame elements for Game and Console
	 * @param systemConfig {object} config data for DOM elements
	 * @param done {function} callback when method has completed
	 * @returns void
	 */
	function create(systemConfig,done) {

		// store reference to subsystem config
		config = systemConfig;

		// Grab reference to the console config
		consoleConfig = config.consoleConfig;

		// Set the layout config for all console frames to follow
		layout = resizeManager.recalculateLayout();
		var lastWindowSizes = resizeManager.getLastWindow();

		// Create and style master container DOM on Gateway
		rootContainer = config.container;
		gameContainer = config.gameContainer;
		widgetContainer = config.widgetContainer;
		rootContainer.id = 'container';
		rootContainer.setAttribute('allowFullScreen', '');

		// Generic styling for main subsystem dom container
		setStyles.call(rootContainer, {
			position: 'fixed', //Do not use position:fixed on mobile, esp. not iOS. //SKATE-3712, temporary set back to fixed
			bottom: 'calc(0px + env(safe-area-inset-bottom) + constant(safe-area-inset-bottom)',
			left: 'calc(0px + env(safe-area-inset-left) + constant(safe-area-inset-left)',
			width: '100%',
			height: '100%', //this should probably be something else, but will get picked up by resizer anyway
			overflow: 'hidden', //FIX SKATE-878 - reverted for SKATE-1138 and 1.3
			touchAction:'pan-y' //SKATE-6556, stop sound option being zoomable on some devices
		});

		//create required subsystem iframe elements
		gameframe = framefactory.create("game");
        if (config.kernelConfig.splashUrl) {
            splashContainer = document.createElement('div');
            splashframe = framefactory.create("splash");
            splashframe.element.src = getUrlWithParams(config.kernelConfig.splashUrl, config.kernelConfig.paramSplash);
            splashframe.element.origin = getUrlOrigin(config.kernelConfig.splashUrl);
        }

		// style subsystem's iframe element
		gameContainer.id="gameContainer";

		setStyles.call(gameContainer, {
			position:"absolute",
			display:"block",
			border:0,
			padding:0,
			left:lastWindowSizes.LCustomViewWidth + "px",
			top:lastWindowSizes.TCustomViewHeight + "px",
			width:window.innerWidth - (lastWindowSizes.LCustomViewWidth + lastWindowSizes.RCustomViewWidth) + "px",
			height:window.innerHeight - (lastWindowSizes.GameTopOffset + lastWindowSizes.BCustomViewHeight) + "px",
			overflow:"hidden",
			visibility:config.kernelConfig.splashUrl?"hidden":"inherit", //Show game if no splash
			zIndex:3
		});
		gameBlocker=document.createElement('div'); //SKATE-6510, this will be revealed above the game to stop interaction
		gameBlocker.id="IXFgameBlocker";
		setStyles.call(gameBlocker, {
			position:"absolute",
			display:"block",
			border:0,
			padding:0,
			left:"0",
			top: "0",
			width:"100%",
			height:"100%",
			overflow:"hidden",
			visibility:'hidden',
			zIndex:4
		});

		widgetContainer.id="widgetContainer";
		setStyles.call(widgetContainer, {
			position:"absolute",
			display:"block",
			border:0,
			padding:0,
			left:lastWindowSizes.LCustomViewWidth + "px",//take left/top/width/height OUT - let the resizer get kicked for that
			top:lastWindowSizes.TCustomViewHeight + "px",
			width:window.innerWidth - (lastWindowSizes.LCustomViewWidth + lastWindowSizes.RCustomViewWidth) + "px",
			height:window.innerHeight - (lastWindowSizes.GameTopOffset + lastWindowSizes.BCustomViewHeight) + "px",
			overflow:"hidden",
			visibility:"hidden",
			zIndex:10
		});

		if (config.kernelConfig.splashUrl) {
            setStyles.call(splashContainer, { //SKATE-4694
                position: "absolute",
                display: "block",
                border: 0,
                padding: 0,
                margin: 0,
                left: 0,
                top: 0,
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                visibility: 'hidden',
                touchAction: 'pan-y'
            });
        }

		gameframe.style({
			position:"absolute",
			border:0,
			padding:0,
			left:0,
			top:0,
			width:"inherit",
			height:"inherit",
			visibility:"inherit"
		});

        if (config.kernelConfig.splashUrl) {
            splashframe.style({
                position: "absolute",
                border: 0,
                padding: 0,
                left: "0px",
                top: "0px",
                visibility: "hidden",
                overflow: "hidden",
                width: "100%",//window.innerWidth+"px",
                height: "100%"//window.innerHeight+"px"
            }); //This has to be window size, not container size to start with because everything explodes otherwise
        }
		// Game frame is added to queued load elements post-splash load.
		//queuedLoadingElements.push(gameframe.element);
		queuedLoadingElements.push(gameContainer);
		queuedLoadingElements.push(widgetContainer);

		// Iterate through object and filter out the custom view nodes
		Object.keys(consoleConfig).filter(function(e) {
			if(consoleConfig[e].hasOwnProperty("consoleUrl")){

				// We have found a valid custom config node
				var node = consoleConfig[e];

				// Create a wrapper for our iframe. Will allow us to handle css styling better
				var consoleContainer = document.createElement('div');
				consoleContainer.id = e; // name the div to the custom view dictionary name eg. 'TCustomView'

				// Keep reference to the wrapped views for resizing later
				customViews[e] = consoleContainer;

				// Apply correct default layout style the element
				setStyles.call(consoleContainer,layout[e]);

				// Create our custom view iframe
				var consoleframe = framefactory.create(e + "Frame");

				// Style the custom view iframe
				consoleframe.style({
					border:0,
					padding:0,
					width:'inherit',
					height:0,//Create 0 high so nothing is visible until we're ready to show it.
					visibility:'inherit',
					overflow:'hidden',
					transform:'translateZ(0)',
					webkitOverflowScrolling: 'touch',
					overflowY: 'scroll',
					overscrollBehaviorY:'none'
				});

				// set the source url
				consoleframe.element.src = getUrlWithParams(node.consoleUrl,consoleConfig.paramConsole);

				// add our shiney new iframe to the wrapped element
				consoleContainer.appendChild(consoleframe.element);

				// queue up the element for adding to the root dom later
				queuedConsoleElements.push(consoleContainer);
			}
		});

		done();
	}

	/**
	 * @function debounce
	 * @description Throttles function calls particularly useful for window resize events
	 * @private
	 * @param func {Function} The function that requires throttling
	 * @param threshold {number} The time in ms between calling the function again
	 * @param execAsap {boolean} Override the throttling and call the function immediately
	 * @returns {debounced}
	 */
	function debounce (func, threshold, execAsap) {
		var timeout;

		return function debounced () {

			var obj = this, args = arguments;

			function delayed () {
				if (!execAsap){
					func.apply(obj, args);
				}
				timeout = null;
			}

			if (timeout){
				clearTimeout(timeout);
			} else if (execAsap){
				func.apply(obj, args);
			}

			timeout = setTimeout(delayed, threshold || 100);
		};
	}

	var sizesDirty=false;



	var gameReady = false;

	/**
	 * @function generateWrappedConfig
	 * @description Creates a smaller config (without the dom references etc) to be passed to components
	 * @private
	 * @instance
	 * @param config {object} Client Config Object
	 * @returns wrappedConfig {object} Reduced config object
	 */
	function generateWrappedConfig(config) {
		var wrappedConfig = {
            authentication:config.authentication,
			consoleConfig:config.consoleConfig,
			deviceConfig:config.deviceConfig,
			gameConfig:config.gameConfig,
			kernelConfig:config.kernelConfig,
			serverConfig:config.serverConfig,
			gameServiceConfig: config.gameServiceConfig,
			widgetConfig: config.widgetConfig,
			stringsConfig:config.stringsConfig
		};
		if (config.hasOwnProperty('Exception')) {
			wrappedConfig.Exception = config.Exception;
		}
		if(config.forceGetParamNames){
			wrappedConfig.forceGetParamNames = config.forceGetParamNames;
		}
		return wrappedConfig;
	}

	
	/**
	 * @function systemInitAndReady
	 * @description Send the Kernel/System.Init, subscribe the Game
	 * @private
	 * @instance
	 * @param void
	 * @returns void
	 */
	function systemInitAndReady(){
		//Subscribe Game API
		bus.subscribe({channel: 'Game', topic: 'Game.Fullscreen', callback: fullScreen});
		bus.subscribe({channel: 'Game', topic: 'Game.Capabilities', callback: function(capabilities){
			//the data may be like {switchPlayMode: true, webGL: false}ver
			gameCapabilities = JSON.parse(JSON.stringify(capabilities));
			Object.freeze(gameCapabilities);
			bus.publish({channel: 'Kernel', topic: 'Game.Capabilities', data: capabilities});
		}});//TODO

		gameReady = true;

		bus.publish({channel:"Kernel",topic:"System.Init",data:wrapperedConfig});

		resizeManager.resizer();

		// Check if subsystems could be ready at this point.
		onSubsystemsReady();
	}

	/**
	 * @function onSubsystemLoadProgress
	 * @description Listens to progress events from registered subystems
	 * @private
	 * @instance
	 * @param payload {object} Message Payload
	 * @param envelope {object} Full message envelope (including channel,topic etc)
	 * @listens Kernel.LoadProgress
	 */
	function onSubsystemLoadProgress(payload, envelope){
		// Store publisher of load progress (it's okay to keep overwriting this value in dictionary)
		publishers[payload.id] = payload;

		// Wait for all subsystems to send their first load progress before muxing to progress bar
		var loadProgressContinue = 1;
		var loaded = 0;
		var remaining = 0;
		var complete = false; // a flag to inform kernel that all subsystems have or have not completed their loading.
		var completed = 0; // count of publishers who have completed their loading

		//This code waits for all items to be registered before calling internal init + listening for config update
		//Possible race is that we launch ISB, but the adapters don't send an initial load progress
		//ClientService.ConfigUpdate happens after auth, but if the game has yet to start loading (ISB), it's possible that the event won't
		//Be subscribed yet, so it will miss entirely.  To fix this we will start with game in publishers list by default.
		for(var publisher in requiredPublishers){
			if(!publishers[publisher]){ //This waits until consoleservice, clientservice, game and (optionally) gameservice are talking
				loadProgressContinue = 0;
			}else{
				loaded += Number(publishers[publisher].current || 0); //Fix unit tests breaking when no progress ever happens
				remaining += Number(publishers[publisher].items || 0);

				// keep tally of completed status for each publisher
				completed += Number(publishers[publisher].complete || publishers[publisher].fail) ? 1 : 0;

				//  SKATE-1572
				if(!internalInit &&
					//publishers["game"] && //Existence of this means games have handshaked AND dom is ready
					publishers["consoleservice"] && publishers["consoleservice"].complete === true &&
					publishers["clientservice"] && publishers["clientservice"].complete === true){

					if(!requiredPublishers["gameservice"] || //only when gameservice available
						(publishers["gameservice"] && publishers["gameservice"].complete === true)){
						internalInit = true;

						var configUpdateSubscriber = bus.subscribe({channel:"ClientService",topic:"ClientService.ConfigUpdate", callback: function (data) {

							wrapperedConfig = generateWrappedConfig(config);
							if(data){
								if(data.paramGame){
									wrapperedConfig.gameConfig.playMode = data.paramGame.playMode;
									wrapperedConfig.serverConfig.paramGame.playMode = data.paramGame.playMode;
									//Added for Dani; we should probably more clearly remap from UpdateClientConfig, I don't know if bespoke ISB events are the best source but it'll work for now
									config.serverConfig.paramGame.rgsPlayMode = data.paramGame.playMode;
								}
		
								if(data.freespin){
									if(data.freespin.hasOwnProperty('freespin_lines') && data.freespin.freespin_lines!==undefined && data.freespin.freespin_lines!==null){
										wrapperedConfig.serverConfig.freespin_lines = data.freespin.freespin_lines;
									}
									if(data.freespin.hasOwnProperty('freespin_bet') && data.freespin.freespin_bet!==undefined && data.freespin.freespin_bet!==null){
										wrapperedConfig.serverConfig.freespin_bet = data.freespin.freespin_bet;
									}
								}
								//SKATE-4607 update clientConfig for black jack PFS
								if(data.minbet){
									wrapperedConfig.gameConfig.minbet = data.minbet;
								}
							}
							
							wrapperedDataReady = true;

							if(gameLoadComplete){ // if the game load completed before the config update //this will now never happen
								systemInitAndReady();
							}

							bus.unsubscribe(configUpdateSubscriber);
						}});

						// Once clientservice and consoleservice subsystems have loaded, call out System.InternalInit with Client Config
						// This next line is why createDOM is moved to be sooner
        	            bus.publish({channel:"Kernel",topic:"System.InternalInit",data:generateWrappedConfig(config)});
						window.postMessage({IXFStatus: "LoadComplete"}, window.location.origin);
					}
				}

				if(publisher === "game" && publishers[publisher].fail){
					loadingFailedReason = "game";
				}
				if(publisher === "consoleservice" && publishers[publisher].fail){
					loadingFailedReason = "console";
				}

				loadingFailed = loadingFailed || publishers[publisher].fail;

				// if all required publishers for load progress report 'complete' then load is complete
				// and ready. Note, only when 'complete' is marked as true for each publisher will loading/init be considered
				// complete. Subsystems can repeatedly publish load progress messages with 'complete' false if they are still initialising.				
			}
		}
		if(loadingFailed){
			loadingFailedHandler();
			bus.unsubscribe(progressSubscriber);
			return; //Nothing should be done after this
		}
		if (loadProgressContinue) { // Do not post any progress data until we have all the required publishers hooked up.
			updateLoadProgress(loaded, remaining, checkLoadComplete());
		}
	}

	function updateLoadProgress(loaded, remaining, complete) { //Updating the load progress clears the timeout, but checkLoadComplete re-asserts it to be safe
		//Watchdog timeout handled in checkLoadComplete now

		// Calculate the percentage of all combined publishers payloads as % of total & publish
		var percent = Math.min(Math.round((loaded/remaining) * 100),100);

		// Use bare post message on splash iframe and notify current loading progress
		if(splashframe && splashframe.element && splashframe.element.contentWindow){ //Workaround unit tests sending progress early
			splashframe.element.contentWindow.postMessage(
				{
					loaded:percent,
					complete:complete
				}, splashframe.element.origin
			);
		}
	}

    function checkLoadComplete() {
		if (loadingTimeout) { // Clear the watchdog timeout as we know the loading in progress at this moment
			clearTimeout(loadingTimeout);
			loadingTimeout = void(0);
		}

        var complete=false;
        //SKATE-3341: Instead of kicking everything off when the required publishers are ready, we must wait for ALL LoadProgress
        //This means the GSP can trigger additional component loading easily.
        var loadingModules = Object.keys(publishers).filter(function(id){
            return !publishers[id].complete;
        });
		//SKATE-3998 - wait for clientServiceInitialised - ie, auth etc - before marking ready.  This will give the internals time to load bolt on
        if(/*clientServiceInitialised &&*/ internalInit && loadingModules.length === 0) { // all required modules AND extra modules are load completed
            complete = true;
        }

		// check if required publishers are all reporting complete before continuing
		if (complete){
        	gameLoadComplete = true;


            /* //This is handled by systemInitAndReady, it should only fail if wrapperedConfig is missing
            //TODO - check this next part is needed for RGS games?
			if (clientServiceInitialised) { //Somehow this was missing
				onSubsystemsReady();
			}
            */

            var gameLoadedElapse = Date.now() - gameLoadingStartTimestamp;
            cecCommand.postLaunchTimes({event: "GameLoadComplete", gameLoadedElapse: gameLoadedElapse});

            // stop listening to progress load events
            bus.unsubscribe(progressSubscriber);

            if(wrapperedConfig){ // if the game load completed after config update
            	systemInitAndReady();
			}

		} else{
			// Set a new timeout to take care the load progress interrupted expected
			loadingTimeout = handshakeTimeout(); //0 gets ignored
		}
		return complete;
    }

	/**
	 * @function handshakeTimeout
	 * @description Monitors the handshakes for subsystem components and reports network error if timeout value exceeded
	 * @param timeout {number} ms value to wait before network error is fired
	 * @returns {*|number}
	 */
	function handshakeTimeout(timeout) {
		return setTimeout(
			function () {
				// Debug message
				logger.error("handshakeTimeout error.", "SubsystemManager");
				if(gameframe.element){ //SKATE-2387
					gameframe.element.src = ""; //void(0);
					if(gameframe.element.parentElement){
						gameframe.element.parentElement.removeChild(gameframe.element);
					}
				}
				loadingFailed = 1;
				if (internalInit) {
					//Already initialised, throw a subcomponent load error.
					bus.publish({channel: "Kernel", topic: "ErrorHandler.Throw", data: {errorCode:'FT-003', priority : 0}});
				}
				if (bus && !loadFailDebounce) {
					//handshake timeout means network error, mark all of components load complete to init errorhandler //THIS IS PROBLEMATIC!  It triggers a re-fail of the message every 30s
					bus.publish({channel: "Kernel",topic: "LoadProgress",data:{id:"game",items:'10',current:'10',complete:true}});
					bus.publish({channel: "Kernel",topic: "LoadProgress",data:{id:"consoleservice",items:'10',current:'10',complete:true}});
					bus.publish({channel: "Kernel",topic: "LoadProgress",data:{id:"clientservice",items:'10',current:'10',complete:true}});
					bus.publish({channel: "Kernel",topic: "LoadProgress",data:{id:"gameservice",items:'10',current:'10',complete:true}});
				}
				loadFailDebounce = true;
			}, timeout || 30000
		);
	}

/**
 * @description Trigger the GM-012 sound request message, if required
 * @param done
 */
	function checkSound(done) { //SKATE-5546 Trigger the GM-012 message. Check. Check 1 2.
		var soundCheck = {"Id":"GM-012","Reference":"GM-012","Message":config.stringsConfig.soundPromptMessage||"Enable Sound?",
			"Buttons": {
				"Button": [
					{"Text":config.stringsConfig.btnNo||'NO',"Cmd":{"@name":"startMuted"}},
					{"Text":config.stringsConfig.btnYes||'YES',"Cmd":{"@name":"continue"}}
				]
			}
		};
		bus.request({channel: "Kernel", topic: "ErrorHandler.Throw", data:  {
			errorCode:'CD-100', exceptionData:soundCheck }},
			function(response){
				if (response && response.cmd && response.cmd.name === 'startMuted') {
					done(false);
				} else {
					done(true);
				}
			},
			function(resp){
				console.log('Some kind of error',resp);
			}
		);
	}

	function removeLoadImageAndSetBlackBackground() {
		//SKATE-993
		var loadImage = document.getElementById('loader');
		if (loadImage) {
			document.body.removeChild(loadImage);
			loadImage = null;
		}
		//SKATE-1405
		document.body.style.backgroundColor = 'black';
	}

	/**
	 * @function load
	 * @description Begins IFrame contents loading by adding IFramed subsystem elements to the DOM
	 * @param done {function} callback when loaded
	 * @private
	 * @instance
	 */
	function load(onloadConsole, done){
		
		gameLoadingStartTimestamp= Date.now();

		// Wait for handshake message from Splash before proceeding to add other subsystems to DOM
		// We could use onload event but this requires knowledge of the splash internal DOM 'readyiness'
		// Better to wait for explicit handshake from Splash as it will know when it is actually ready.
		(function splashHandShake(){
			var splashTimeout = handshakeTimeout();

			// Wait for Splash Page handshake before continuing with load
			// We use onload here for avoiding cross domain issue when
			var splashLoaded = function splashHandshakeListener(e){
				// Clear the timeout watchdog on Splash Frame
				clearTimeout(splashTimeout);
				//clearTimeout(loadingTimeout); //Just in case of load race - it's possible for the game to load before it's added to the DOM.
				//^^ TODO - Investigate splash clearing the general loadTimeout
				//Technically it *should not* be possible for a game to load without being added to dom
				//That's not how iframes work.  I think this timeout actually give ISB games a bit more time before
				//They trigger that first game load progress event
				// PLAYAUF-3249 fill splashframe's width and height value before showing it 
				sizesDirty = true;
				resizeManager.resizer();
				// Show the splash page now we know it has handshaked successfully
                if (splashContainer) {
					splashContainer.style.visibility = 'inherit';
					splashframe.show();
				}
				//When Splash added, set loader background to black
				if(config?.serverConfig?.thirdPartyCode !== 'pt') {
					removeLoadImageAndSetBlackBackground();
				}
				sizesDirty = true; //At this point a reflow is needed to make sure everything is still fine
				// Once we have handshaked with splash we should stop listening
				//ECMAScript 3 workaround for needing to unlisten to inline function by naming it

				for (var element in queuedLoadingElements){
					if (splashframe) {
						rootContainer.insertBefore(queuedLoadingElements[element], splashContainer);
					} else {
						rootContainer.appendChild(queuedLoadingElements[element]);
					}
				}

				done();
			};
			if (splashframe) {
				splashframe.element.onload = splashLoaded;
			} else {
				splashLoaded();
			}
		})();
		sizesDirty = true; //One reflow
		// Load splash screen
		if (splashContainer) {
			splashContainer.appendChild(splashframe.element); //SKATE-4694
			rootContainer.appendChild(splashContainer);
		}

		// SKATE-1627
		// Pass all console elements to console service for initialization

		//At this point we have no running timeout, but throw a FT-006 from ConsoleConnector if they fail to handshake

		onloadConsole(queuedConsoleElements, function consoleInitializedListener(initData){
			// Add behaviour when all consoles initialize completed
			//Check for Exception which triggers a full on load
			if (config.Exception) {
				if (loadingTimeout) {
					clearTimeout(loadingTimeout);
				}
				loadingFailed = 1;
				loadingFailedReason = "server";
				bus.publish({channel:"Kernel",topic:"System.InternalInit",data:generateWrappedConfig(config)});
				sizesDirty = true; //force reflow (unblock heights set to 0 for pre-load)
				resizeManager.resizer();
				return; //Here we totally bypass the loading process.  No need, it's all on fire.
			}
			//Set new data
			if (initData) {
				if (initData.playMode) {
					config.kernelConfig.paramSplash.playMode = initData.playMode;
					config.serverConfig.paramRGS.playMode = initData.playMode;
					config.serverConfig.paramGame.playMode = initData.playMode;
					config.serverConfig.playMode = initData.playMode;
				}
				Object.keys(initData).forEach(function(item) {
					if (item.indexOf('freespin') >= 0) { //In place of a white list, filter to ONLY apply freespin params
						if(initData[item]!==undefined && initData[item]!==null){ //RGS-32980: Java can't read undefined values, so skip them
							config.serverConfig[item] = initData[item];
							config.serverConfig[item] = initData[item];
						}
					}
				});
			}

			//load game
            sizesDirty=true;
            resizeManager.resizer();
				//Third party Specific stuff will exist
				if (config?.serverConfig?.thirdPartyCode) {
					switch(config.serverConfig.thirdPartyCode) {
						case 'evr' :
							config.serverConfig.paramGame.integration='fusion'; //Parameter needed for selecting adapter
                            if (config.serverConfig.sessionToken) {
								config.serverConfig.gameUrl += ";"+config.serverConfig.sessionToken; //SKATE-6116
							}
							//modify language to match RGS-31840
							var mockParamGame = JSON.parse(JSON.stringify(config.serverConfig.paramGame));
							if(config.serverConfig.paramRGS?.language){
								mockParamGame.language = config.serverConfig.paramRGS.language;
							}
							gameframe.element.src =  getUrlWithParams(config.serverConfig.gameUrl,mockParamGame);
							break;
						case 'pt':
							config.serverConfig.paramGame.integration='ucip';
							config.serverConfig.paramGame.logoutMode='1'; //SKATE-6793
							gameframe.element.src =  getUrlWithParams(config.serverConfig.gameUrl,config.serverConfig.paramGame);
							break;
						default:
							gameframe.element.src =  getUrlWithParams(config.serverConfig.gameUrl,config.serverConfig.paramGame);
							break;
					}
				} else {
					gameframe.element.src =  getUrlWithParams(config.serverConfig.gameUrl,config.serverConfig.paramGame);
				}

//			}

			function startGameLoading(){
				loadingTimeout = handshakeTimeout();
				gameContainer.appendChild(gameframe.element); //Start load, systems are ready
				if (config?.serverConfig?.thirdPartyCode !== 'isb') { //Don't block ISB games, as the widgets might be *in* the game frame
					gameContainer.appendChild(gameBlocker); //For blocking unpausable games and during transitions between game modes
				}
			}

			function decorateStartGameLoading(startGameLoadingFunc){
				return function(){
					if(config.serverConfig.thirdPartyCode === 'pt'){
						//For PT Games specially
						logger.log("Requesting SSE Connect for PT game");
						bus.request({channel: 'ClientService', topic: 'ThirdParty.SSEConnect', data: null}, function(data){
							logger.log("Starting game load after SSE Connect for PT game");
							removeLoadImageAndSetBlackBackground();
							startGameLoadingFunc();
						}, function(err){
							//handled in SSEErrors.js.
						});
					} else {
						//For RGS Games and other third party games
						startGameLoadingFunc();
					}
				};
			}

			var startGameLoadingWithSSE = decorateStartGameLoading(startGameLoading);

			if (config.serverConfig.thirdPartyCode/* === 'isb'*/) {
				//wait for full subsystem to load
				//sound Control Handler here
				var soundCheckThen3PLoad = function() {
					if (config.serverConfig.thirdPartyCode!=='pt' && config.kernelConfig.showSoundPrompt) { //SKATE-5546 - if we show popup
						checkSound(function (startWithSound) {
							bus.publish({channel: 'Kernel', topic: 'Game.StartMuted', data: startWithSound});
							startGameLoadingWithSSE();
						});
					} else {
						startGameLoadingWithSSE();
					}
				};
				//This is the last point before we add the 3P game to the DOM
				//We need to do the sound check here, then load 3P.
				//This is part of the load flow, moved from auth at request.
                if (clientServiceInitialised) {
					soundCheckThen3PLoad();
				} else { //Wait for client service
					bus.subscribe({ //This is very odd!  Breaks for other providers if I remove the ISB check
						channel: "ClientService", topic: "ClientService.InitDone", callback: function () { //ClientService.InitDone //Deferring iframe creation until the point which we have config out of the way!
							soundCheckThen3PLoad();
						}
					});
				}
//				initGameBridge(bus, gameframe); //Should this be here? //this isn't actually needed here, we can still wire up to it as it's created
			} else {
				startGameLoading();
			}
		});

		//SKATE-1426 - make this happen BEFORE the consoles are added

		resizeManager.init({
			bus:bus,
			config:{
				container: /*gameContainer?gameContainer:*/rootContainer,
				gameContainer:gameContainer,
				gameframe: gameframe,
				widgetContainer: widgetContainer,
				splashContainer: splashContainer,
				splashframe: splashframe,
				gameBlocker: gameBlocker,
				customViews:customViews,
				dragNotifyTime : 1000,
				dragScreen : config.serverConfig.presenttype==='STD' && config.serverConfig.channel !== 'INT'
			}
		}); //This is where you want the resizer happening

		// Ensure resize happens immediately - PR-1859 + SKATE-1405
//		resizeManager.resizer();

		// Start loading console
		for (var element in queuedConsoleElements){
			rootContainer.appendChild(queuedConsoleElements[element]);
		}

		config.body.appendChild(rootContainer);

		resizeManager.resizer(); //First kick
	}

	/**
	 * @function loadingFailedHandler
	 * @description Handle IFrame contents loading failed cases
	 * @param 
	 */
	function loadingFailedHandler(){
		gameframe.element.src = ""; //void(0);
		if (gameframe.element.parentElement) {
			gameframe.element.parentElement.removeChild(gameframe.element);
		}
		//SKATE-3772:Refine FT-001 to use a different ID for different fail cases
		// if (config.Exception) {
		// 	logger.log('We should be throwing '+config.Exception.Id+' now');
		// 	bus.publish({channel: "Kernel", topic: "ErrorHandler.Throw", data:  {errorCode:config.Exception.Id, priority : 0}});
		// }
		//SKATE-5468: Refine FT-001 to use a different ID for different fail cases

		if (loadingFailedReason) {
			switch (loadingFailedReason) {
				case 'game':
					//game fails to load
					bus.publish({channel: "Kernel", topic: "ErrorHandler.Throw", data:  {errorCode:'FT-008', priority : 0}});
					break;
				case 'server':
					//clientconfig sends exception
					bus.publish({channel: "Kernel", topic: "ErrorHandler.Throw", data:  {errorCode:'FT-007', priority : 0, exceptionData:config.Exception}});
					break;
				case 'console':
					bus.publish({channel: "Kernel", topic: "ErrorHandler.Throw", data:  {errorCode:'FT-006', priority : 0}});
					break;
				default:
					bus.publish({channel: "Kernel", topic: "ErrorHandler.Throw", data:  {errorCode:'FT-001', priority : 0}});
					break;
			}
		} else {
			bus.publish({channel: "Kernel", topic: "ErrorHandler.Throw", data:  {errorCode:'FT-001', priority : 0}});
		}
	}


	/**
	 * @function onSubsystemsReady
	 * @description callback for when all subsystems are loaded and ready
	 * @param
	 * @fires Kernel.System.Ready
	 */
	var subsystemReady = false; //avoid small possible ISB race
	function onSubsystemsReady(){
		if (subsystemReady) {
			return;
		}
		if (loadingFailed) {
			loadingFailedHandler();
			return;
		}
		if(clientServiceInitialised && consoleServiceInitialised && wrapperedDataReady &&
				gameLoadComplete && (!gsEnabled || gsEnabled && gameServiceInitialised)){
			subsystemReady = true; //Prevent System Ready double-sending
			bus.publish({channel: "Kernel", topic: "System.Ready", data: {}});
			cecCommand.postLaunchTimes({event:"SystemReady", systemLoadEndTimestamp:Date.now()});
		} else {
			return;
		}
	}

	/**
	 * @function reveal
	 * @description Continuation to call when State Controller is ready to set game to initial state
	 * @private
	 * @instance
	 */
	function reveal(){
		gameContainer.style.visibility='inherit';
		gameframe.show();

		if (splashframe) {
			splashContainer.style.visibility='hidden';
			splashframe.hide();
		}

		sizesDirty = true;
		resizeManager.resizer(); //Force a resize the first time everything is made visible, just as a safety
	}

	/**
	 * @function fullScreen
	 * @description Handles FullScreen API requests sent via Game Framework FullScreen API
	 * @listens Game.Game.Fullscreen
	 * @param data Postal JS Message Payload - Not consumed by this method
	 * @param envelope Postal JS Message Full Enveloper - Not consumed by this method
	 * @instance
	 * @private
	 */
	function fullScreen(data,envelope){
		//IGNORE if in an iframe!
		if (window.parent !== window) {
			return; //Fullscreen within an iframe is dangerous - could hide the console.
		}
		//API Deprecated - now handled within the platform.
	}
	/**
	 * @function getUrlWithParams
	 * @instance
	 * @description generate URL with query string
	 * @param url {string} - Service URL to do get request
	 * @param paramMap {map} - parameters map, will be serialzied and append as url query string
	 * @returns URL with query string
	 * @private
	 */
	function getUrlWithParams(url, paramMap){
		var urlWithParams = url;
		if(paramMap!==null&&paramMap!==undefined){
			if(urlWithParams.indexOf('?')<0){
				urlWithParams+='?';
			}else{
				urlWithParams+='&';
			}
			if(typeof paramMap !== 'object'){
				urlWithParams+=encodeURIComponent(paramMap);
			}else{
				for(var k in paramMap){
					urlWithParams+=encodeURIComponent(k);
					urlWithParams+='=';
					urlWithParams+=encodeURIComponent(paramMap[k]);
					urlWithParams+='&';
				}
			}
			if(urlWithParams.match(/[&\?]$/)!==null){
				urlWithParams = urlWithParams.substring(0, urlWithParams.length-1);
			}
		}
		return urlWithParams;
	}

    function setCECCommand(cmd) {
    	cecCommand = cmd;
    	resizeManager.setCECCommand(cmd);
    }

	export default function(){

		return{
			init:init,
			create:create,
			load:load,
			reveal:reveal,
			onloadConsole: function(callback){
				callback(queuedConsoleElements);
			},
			setCECCommand:setCECCommand,
            getGameFrame:function(){
                return gameframe;
            }
		};
	}
//});
